import { ca } from '@cian/analytics';

import { IAgentSchema, IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { getCustomUrl } from '../../utils/tracking/getCustomUrl';
import { getProduct } from '../../utils/tracking/getProduct';

interface ITrackModalOpenParams {
  label?: string;
  chatId?: string;
  type?: 'open_phone' | 'open_message';
}

export function trackModalOpen({ label, chatId, type }: ITrackModalOpenParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Message_popup',
    action: type || 'open',
    label,
    useLastProducts: true,
    page: {
      pageType: 'Card',
      siteType: 'desktop',
      extra: {
        productid: chatId,
      },
    },
  });
}

/* istanbul ignore next */
export function trackAgentAvailabilityMessageSent(offer: IOfferSchema, agent: IAgentSchema | null) {
  ca('event', {
    action: 'send_message_inactive',
    category: 'Message_popup',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    products: getProduct(offer, agent),
  });
}
